export default class SaveOnNavigate {
  constructor() {
    this.bindSaveHandler();
  }

  bindSaveHandler() {
    N2.handle('click', '[data-save-on-nav]', function(evt) {
      N2.showProgressIndicator();
      evt.preventDefault();
      let anchor = $(this);
      let destination = anchor.prop('href');
      let $whereTo = $('input#destination');

      $whereTo.
        // set the destination to go to after saving
        val(destination).
        // find the associated form object
        closest('form').
        data('remote', false).
        // set auto-hide of loading indicator on ajax complete to off
        data('dismiss', null).
        // set toast on ajax success/fail to off
        data('toast', false).
        // submit the form
        submit();
    })
  }
}
